import { FilterId, type PrimaryFilterId } from '../../../filters/types/filters';
import { EntitySummaryDataProvider } from '../../DataProvider/EntitySummaryDataProvider';
import { ChartFallback } from '../ChartFallback';
import { ChartNotSupported } from '../ChartNotSupported';
import { CompanySummary } from './CompanySummary';
import { RoleSummary } from './RoleSummary';

export const EntitySummary = ({
  primaryDimension,
}: {
  primaryDimension: PrimaryFilterId;
}) => {
  return (
    <EntitySummaryDataProvider primaryDimension={primaryDimension}>
      {({ data, status }) => {
        if (primaryDimension === FilterId.COMPANY && data) {
          return (
            <ChartFallback status={status}>
              <CompanySummary data={data} />
            </ChartFallback>
          );
        }
        if (primaryDimension === FilterId.ROLE && data) {
          return (
            <ChartFallback status={status}>
              <RoleSummary data={data} />
            </ChartFallback>
          );
        }
        return <ChartNotSupported />;
      }}
    </EntitySummaryDataProvider>
  );
};
